var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQr = function SvgQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "qr_svg__Capa_2",
    viewBox: "0 0 89.21 88.22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.08,
    height: 84.08,
    x: 5.12,
    y: 4.14,
    rx: 31.83,
    ry: 31.83,
    fill: "#11554f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 84.08,
    height: 84.08,
    x: 0,
    rx: 30.32,
    ry: 30.32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.18 75.29h-6.8c-10.34 0-18.76-8.41-18.76-18.76v-6.54h8.91v6.54c0 5.43 4.42 9.85 9.85 9.85h6.8zM18.54 33.91H9.63v-6.36c0-10.34 8.41-18.76 18.76-18.76h6.8v8.91h-6.8c-5.43 0-9.85 4.42-9.85 9.85zM76.12 33.91h-8.91v-6.36c0-5.43-4.42-9.85-9.85-9.85H51.1V8.79h6.26c10.34 0 18.76 8.41 18.76 18.76z",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.88 60.23c.81-.81.81-2.13 0-2.95l-3.16-3.16c-.81-.81-2.13-.81-2.95 0l-2.62 2.62-5.31-5.38a18.43 18.43 0 0 0 2.54-9.32c0-10.22-8.29-18.51-18.51-18.51s-18.51 8.29-18.51 18.51 8.29 18.51 18.51 18.51c3.6 0 6.95-1.04 9.79-2.82l12.7 12.7c.6.64 1.45 1 2.33 1h2.74c1.2 0 2.17-.97 2.17-2.17v-2.75c0-.87-.35-1.7-.98-2.3l-1.32-1.28-.06-.06 2.65-2.65ZM33.25 42.04c0-5.31 4.31-9.62 9.62-9.62s9.62 4.31 9.62 9.62-4.31 9.62-9.62 9.62-9.62-4.31-9.62-9.62",
    fill: "#500d76"
  }))));
};
export default SvgQr;